import React from 'react';
import cn from 'classnames';

import { EStatus, IStatusTagProps } from './StatusTag.types';

import './StatusTag.scss';

const StatusTag: React.FC<IStatusTagProps> = ({ status }) => {
	const className = cn('f5gStatusTagContainer', {
		'f5gStatusTagActive': status === EStatus.active,
		'f5gStatusTagBlocked': status === EStatus.blocked,
	});

	return (
		<div className={className}>
			{status === EStatus.active ? 'Active' : 'Blocked'}
		</div>
	);
};

export default StatusTag;
